import React, {useState, useEffect, Fragment} from 'react'
import {Button, Card, Col, Container, Form, Row, Toast, Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {CarpetaDigitalComponent} from 'reccol-caso-general'
import {useFormik} from 'formik'
import { Auth } from 'recupero-comunes'
import { useLocation, useNavigate } from 'react-router-dom'
import Bitacora from '../bitacora';
import { configuracionForm, obtenerComboRecepcionar, obtenerResponsablePreAsignado, obtenerComboTipoGestion, postRecepcionarAction } from '../../store/actions/gestion-casos-action'
import { LoadingComponent } from 'recupero-comunes'
import { validationSchemas } from '../../common/validation-Schemas-Recepcionar'
import Mensajes from '../mensajes';

const Formulario = ({datosCaso, idTarea}) => {

const [showToast, setShowToast]=useState(false)
const [loading, setLoading]=useState(false)
const {state}=useLocation()
const queryState=JSON.parse(localStorage.getItem('filtrosAreaGestion'))
const history =useNavigate()
const { rutUsuario } = Auth.currentUser()
const [recepcionar,setRecepcionar]=useState('')
const [comentario,setComentario]=useState('')
const [isCheckedAR, setIsCheckedAR] = React.useState(false)
const [isCheckedCTG, setIsCheckedCTG] = React.useState(false)
const [showBitacora, setShowBitacora] = useState(false)
const [showCarpeta, setShowCarpeta] = useState(false)
const [asignaManual, setAsignaManual] = useState(false)
const [opcionRadio, setOpcionRadio] = useState("")
const [disabled, setDisabled] = useState(true)

const handleShowToast = () => setShowToast(true)
const handleCloseToast = () => setShowToast(false)
const handleShowBitacora = () => setShowBitacora(true)
const handleCloseBitacora= () => setShowBitacora(false)
const handleCloseCarpeta= () => setShowCarpeta(false)
const handleShowCarpeta= () => setShowCarpeta(true)
const dispatch = useDispatch()
  
const data_encargado = useSelector((state) => state.encargadoCompaniaReducer)
const {llaves} = data_encargado
const data_gestion = useSelector((state) => state.gestionCasoReducer)
const {cfg_form, comboRecepcionar, respuestaProcesar, responsable, comboTipoGestion} = data_gestion
    
    useEffect(() => {
       
        if (llaves) {            
            setLoading(true)
            const query = 'ewoicnV0Y2lhIjo5OTA2MTAwMCwKImlkZm9ybSI6IDMKfQ=='
            dispatch(configuracionForm(query))
            .then(()=>{
                let query = Buffer.from(JSON.stringify({concepto: '200'})).toString('base64')
                dispatch(obtenerComboRecepcionar(query))
            })
            .then(()=>{
                let query = Buffer.from(JSON.stringify({concepto: '235'})).toString('base64')
                dispatch(obtenerComboTipoGestion(query))
            })
            .then(()=>{
                let query = Buffer.from(JSON.stringify({idCaso: llaves && llaves['idCaso'], idImplicado: llaves && llaves['idImplicado'], idOrgCaso: llaves && llaves['idOrgCaso']})).toString('base64')
                dispatch(obtenerResponsablePreAsignado(query))
            })
            .then(()=>{
                setLoading(false)
            })
        }
    }, [dispatch, llaves])
    
    useEffect(()=>{
        if(respuestaProcesar && respuestaProcesar["code"]===1){
           setTimeout(()=> history('/area-gestion-compania',{state:{queryState}}),2000)      
        }
    },[respuestaProcesar])

    useEffect(()=>{
        if(responsable && (responsable["idAbogadoPreasignado"] || responsable["idAbogadoRegla"])){
            setDisabled(false);
        }
    },[responsable])

    const handleChangeRadio = (e) => {
        setOpcionRadio(e.target.value);
        if (e.target.value == 1) {
            setIsCheckedAR(true);
            setIsCheckedCTG(false);
        } else {
            setIsCheckedAR(false);
            setIsCheckedCTG(true);
        }
    }
    const handleReset = () => {
        formik.resetForm();
        setIsCheckedAR(false);
        setIsCheckedCTG(false);
        setOpcionRadio("");
        setComentario("");
        setAsignaManual(false);
        setRecepcionar("");
    }
    const formik = useFormik({
        initialValues: {
            "idOrgCaso": "",
            "idCaso": "",
            'estadoCaso': '',
            "observacion": "",
            'usuario':'',
            'IdImplicado':'',
            'flujoGestion':'',
            'chkAM':''
        },
         validationSchema: validationSchemas(recepcionar, opcionRadio),
        onSubmit: (formData) => {
            
            const dataForm = {
                ...formData
            }
           
            dataForm['idCaso'] = llaves && llaves['idCaso']           
            dataForm['idOrgCaso'] = llaves && llaves['idOrgCaso']
            dataForm['usuario'] = rutUsuario && rutUsuario
            dataForm['IdImplicado'] = llaves && llaves['idImplicado']
            dataForm['asignaManual'] = asignaManual;
            dataForm['opcionRadio'] = opcionRadio;
            dataForm['origenPreasignado'] = responsable && responsable['idAbogadoPreasignado'] ? 287001 : responsable && responsable['idAbogadoRegla'] ? 287002 : 0;
            dataForm['idAbogadoPreasignado'] = responsable && responsable['idAbogadoPreasignado'] ? responsable['idAbogadoPreasignado'] : responsable && responsable['idAbogadoRegla'] ? responsable['idAbogadoRegla'] : "";
            dataForm['nombreAbogadoPreasignado'] = responsable && responsable['idAbogadoPreasignado'] ? responsable['nombreAbogadoPreasignado'] : responsable && responsable['idAbogadoRegla'] ? responsable['nombreAbogadoRegla'] : ""
            dataForm['idTipoGestionActual'] = datosCaso && datosCaso['IdTipoGestion'];
            dataForm['idTarea'] = idTarea;
            //console.log("dataForm: ", dataForm);
            setLoading(true)
            dispatch(postRecepcionarAction(dataForm)).then(()=>setLoading(false))
            handleShowToast()        
        }
    })
    return (
    <>
    <style type='text/css'>
        {`
        .btn-carpeta {
            background-color: #F0AD3E;
            color: #FFFFFF;
            width: 140px;
        }
        .btn-carpeta:hover{
            background-color:#e1b97f;
            color: #FFFFFF;
        }
        .btn-bitacora {
            background-color: #55B2CE;
            color: #FFFFFF;
            width: 140px;
        }
        .btn-bitacora:hover{
            background-color: #87c9dc;
            color: #FFFFFF;
        } 
        .btn-cambiar {
            background-color:  #286FBF;
            color: #FFFFFF;
            width: 140px;     
            padding:6px 0px 6px 0px;
        }
        .btn-cambiar:hover{
            background-color:  #5b9ad1;
            color: #FFFFFF;
        }
        .btn-actualizar {
            background-color: #C14B49;
            color: #FFFFFF;
            width: 140px;
            padding:6px 0px 6px 0px;
        }
        .btn-actualizar:hover{
            background-color:  #F6897E;
            color: #FFFFFF;
        }
        .btn-recepcionar {
            background-color: #C14B49;
            color: #FFFFFF;
            width: 140px;
            padding:6px 0px 6px 0px;
        }
        .btn-recepcionar:hover{
            background-color: #F6897E;
            color: #FFFFFF;
        }
        .btn-volver {
            color: #66CCCC;
            border: 1px solid #C00
            width: 140px;
        }
        .btn-tamano{
            padding: 1rem 1.5rem;
            font-size: 1.5rem;
        }
        .btn-limpiar {
            background-color: #F0AD3E;
            color: #FFFFFF;
            width: 140px;
            
        }
    `}
      </style>
      <LoadingComponent show={loading}/>
      <Bitacora
        handleCloseBitacora={handleCloseBitacora}
        showBitacora={showBitacora}
      />
      <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">
        <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
            idCaso={llaves && llaves['idCaso']}
            idImplicado={llaves && llaves['idImplicado']}
            idOrganizacionCaso={llaves && llaves['idOrgCaso']}
            prototipo={2}            
        />  
      </Modal>
      <Container>
      <Form onSubmit={formik.handleSubmit}>
            <Card>
                <Card.Header className='mt-0 mb-0' as='h6' style={{backgroundColor: '#4F517A',color: 'white'}}>
                    {cfg_form ? cfg_form['gestcasos-subtitle'] : ''} 
                </Card.Header>
                <Container>               
                    <Container> {
                        cfg_form ? (
                            <div>
                                <Row>
                                    <Col md='4'>
                                        <Form.Check label= {cfg_form['gestcasos-resp-preasig']} name="group1" type='radio' id='con' value='1'
                                            className='mb-0 mt-4' style={{fontWeight: 'bold', fontSize: '14px'}}
                                            disabled={disabled}
                                            checked={isCheckedAR}
                                            onChange={
                                                (e) => handleChangeRadio(e)
                                            }
                                        /> 
                                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                            {responsable && responsable['idAbogadoPreasignado'] ? responsable['nombreAbogadoPreasignado'] : responsable && responsable['idAbogadoRegla'] ? responsable['nombreAbogadoRegla'] : "" }
                                        </Form.Text>
                                    </Col>
                                    <Col md='4'>
                                        <Form.Label className='mb-0 mt-4' style={{fontWeight: 'bold', fontSize: '14px'}}>
                                            {cfg_form['gestcasos-origen-preasig']}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                            {responsable && responsable['idAbogadoPreasignado'] ? "Core CIA" : responsable && responsable['idAbogadoRegla'] ? "Regla Automática" : ""}
                                        </Form.Text>
                                    </Col>
                                    <Col md='4'>
                                        <Form.Label className='mb-0 mt-4' style={{fontWeight: 'bold', fontSize: '14px'}}>
                                            {cfg_form['gestcasos-cabia-preasig']}
                                        </Form.Label>
                                        <br />
                                        <Form.Check
                                            disabled={disabled}
                                            className='mb-3'
                                            style={{ fontSize: '14px' }}
                                            name='chkAM'
                                            label="Asigna Manual"
                                            checked={asignaManual}
                                            onChange={(e)=>setAsignaManual(e.target.checked)} 
                                        />
                                    </Col>
                                </Row>
                                <hr style={{ color: '#04005D', height: '1px', marginTop:'10px' }}></hr>
                                <Row>
                                    <Col md='4'>
                                        <Form.Check label= {cfg_form['gestcasos-cambio-tg']} name="group1" type='radio' id='con' value='2'
                                            className='mb-0 mt-4' style={{fontWeight: 'bold', fontSize: '14px'}}
                                            checked={isCheckedCTG}
                                            onChange={
                                                (e) => handleChangeRadio(e)
                                            }
                                        /> 
                                        <Form.Select className='mt-2'
                                            name='flujoGestion'
                                            disabled={opcionRadio!=2}
                                            value={formik.values.flujoGestion}
                                            onChange={(e) => {
                                                formik.handleChange(e)
                                            }}
                                            error={formik.errors.flujoGestion}
                                        >
                                        <option value={''}>Seleccione...</option> 
                                        {comboTipoGestion && comboTipoGestion.filter(f=>f.agrupacion == datosCaso?.IdTipoGestion).map(c=>(
                                            <option key={c.id} value={c.id}>{c.nombre}</option>
                                        ))}
                                        </Form.Select>
                                        {formik.errors.flujoGestion ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.flujoGestion}</Form.Text>) :""}                                       
                                    </Col>
                                </Row>
                                <hr style={{ color: '#04005D', height: '1px', marginTop:'30px' }}></hr>
                                <Row>
                                    <Col md='4'>
                                        <Form.Label className='mb-0 mt-4' style={{fontWeight: 'bold', fontSize: '14px'}}>
                                            {cfg_form['gestcasos-cmb-recepcionar']} *
                                        </Form.Label>
                                        <br/>
                                        <Form.Select className='mt-2'
                                            name='estadoCaso'
                                            value={formik.values.estadoCaso=recepcionar}
                                            onChange={(e) => {
                                                formik.handleChange(e)
                                                setRecepcionar(e.target.value)
                                            }}
                                            error={formik.errors.estadoCaso}
                                        >
                                           <option value={''}>Seleccione...</option> 
                                           {comboRecepcionar && comboRecepcionar.filter(f=>f.agrupacion===1).map(c=>(
                                            <option key={c.id} value={c.id}>{c.nombre}</option>
                                           ))}
                                        </Form.Select>
                                        {formik.errors.estadoCaso ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.estadoCaso}</Form.Text>) :""}
                                       </Col>
                                    <Col md='8'>
                                        <Form.Label className='mb-0 mt-4' style={{fontWeight: 'bold',fontSize: '14px'}}>
                                            {cfg_form['gestcasos-tab-descbien-obs']}
                                        </Form.Label>
                                        <br/>
                                        <Form.Control as="textarea" rows={3} 
                                            className='mt-2 mb-2'
                                            onChange={e=>{                 
                                                formik.handleChange(e)
                                                setComentario(e.target.value)
                                            }}
                                            name='observacion'
                                            value={formik.values.observacion=comentario}
                                            error={formik.errors.observacion}  
                                        />
                                      {formik.errors.observacion ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.observacion}</Form.Text>) :""}
                                    </Col>                                
                                </Row>                            
                                <Col> 
                                    {respuestaProcesar && 
                                        <Mensajes
                                            showToast={showToast}
                                            handleCloseToast={handleCloseToast}
                                            delay={5000}
                                            responseData={respuestaProcesar}
                                        ></Mensajes>
                                    }
                                    </Col>
                                </div>
                        ) : null
                    } </Container>
                </Container>        
            <Container>
                <hr style={{ color: '#04005D', height: '1px', marginTop:'30px' }}></hr>
                <Row className='mt-4'>                    
                    <Col className='d-flex align-items-end justify-content-end m-2'>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={()=> history('/area-gestion-compania',{state:{queryState}})}>
                            {cfg_form && cfg_form["gestcasos-btn-volver"]}
                        </Button>
                        <Button className="m-2 w-auto" variant='limpiar' type="button" onClick={() => { handleReset() }}>Limpiar</Button>
                        <Button className='m-2' variant='bitacora' onClick={handleShowBitacora} >
                            {cfg_form && cfg_form["gestcasos-btn-bitacora"]}
                        </Button>
                        <Button className='m-2' variant='carpeta' onClick={handleShowCarpeta} name='carpeta'>
                            {cfg_form && cfg_form["gestcasos-btn-cd"]}
                        </Button>
                        <Button className='m-2' variant='actualizar' type='onSubmit' name='actualizar'>
                            {cfg_form && cfg_form["gestcasos-btn-recepcionar"]}
                        </Button>
                    </Col>
                </Row>
            </Container>
            </Card>
            </Form>
            </Container>                        
        </>
    )
}

export default Formulario
